import PropTypes from "prop-types"

import Shimmer from "components/ui/shimmer"

import CollectionMenuSkeleton from "./collection-menu"
import FeatureGridSkeleton from "./feature-grid"
import TextareaSkeleton from "./textarea"

const LandingLoading = ({ partial }) => {
  return (
    <>
      {!partial && (
        <div className="contained-wide">
          <Shimmer style={{ height: "500px" }} />
        </div>
      )}
      <CollectionMenuSkeleton />
      <TextareaSkeleton />
      <FeatureGridSkeleton />
      {!partial && (
        <>
          <CollectionMenuSkeleton />
          <TextareaSkeleton />
          <FeatureGridSkeleton />
        </>
      )}
      <div className="contained-wide">
        <Shimmer style={{ height: "300px" }} />
      </div>
    </>
  )
}

LandingLoading.propTypes = {
  partial: PropTypes.bool,
}

export default LandingLoading
